import {Nullable} from '../../../app/TypeHelpers'
import {PAYMENT_TYPE} from '../../../CodeMaster'
import {PaymentItem} from '../ReserveFacilityModel'

export abstract class PaymentItemForView {
    id: Nullable<number>
    article: string
    paymentType: PAYMENT_TYPE
    charge: Nullable<number>
    displayOrder: number

    abstract quantityWithUnit(): string

    protected constructor(
        id: Nullable<number>,
        article: string,
        paymentType: PAYMENT_TYPE,
        charge: Nullable<number>,
        displayOrder: number,
    ) {
        this.id = id
        this.article = article
        this.paymentType = paymentType
        this.charge = charge
        this.displayOrder = displayOrder
    }

    toObject(): PaymentItem {
        return {
            id: this.id,
            article: this.article,
            paymentType: this.paymentType,
            charge: this.charge,
            quantityWithUnit: this.quantityWithUnit(),
            displayOrder: this.displayOrder,
        }
    }
}
